import styled from 'styled-components';

interface ITableHeadProps {
  width?: string;
  textAlign?: string;
  textColor?: string|null;
  normalText?: boolean;
  backgroundColor?: string;
  borderStyle?: string;
  padding?: string;
}

export const TableHead = styled.td<ITableHeadProps>`
  width: ${props => props.width || 'auto'};
  max-width: ${props => props.width || 'auto'};
  text-align: ${props => props.textAlign || 'auto'};
  color: ${props => props.textColor || '#74777a'}!important;
  font-weight: ${props => props.normalText ? 'normal' : 'bold'};
  background-color: ${props => props.backgroundColor || 'transparent'}!important;
  border: ${props => props.borderStyle || 'auto'}!important;
  padding: ${props => props.padding || 'auto'}!important;
`;